import { render, staticRenderFns } from "./GameCode.vue?vue&type=template&id=4dcf4ff3&scoped=true"
import script from "./GameCode.vue?vue&type=script&lang=js"
export * from "./GameCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcf4ff3",
  null
  
)

export default component.exports